import PrivateBackendApi from '@/backend';
import {inject} from 'vue';
import {phraseContextKey} from './keys';

const placeholderRegex = /\{(.+?)\}/gi;

export function replace(template: string, values?: { [key: string]: string | number }) {
  template = template.trim();
  if (!values) {
    values = {};
  }

  return template.replace(placeholderRegex, (_, p1: string) => {
    
    if (values) {
      let token = values[p1];
      if (typeof token !== 'undefined') {
        return token.toString();
      }
    }
    
    return `{${p1}}`;
  });
}

/**
 * Creates a factory for usePhrases composition in @hantera/portal-app that is used to get a (possibly) user defined phrase, merged with the given fields
 */
export default function (backendApi: PrivateBackendApi) {

  return (context?: string) => {
    context = context?.trim();
    const globalContext = inject<string>(phraseContextKey, '');

    return (template: string, fields?: { [key: string]: any }) => {
      const languages = [document.documentElement.lang, ...navigator.languages.map(r => r.substring(0, 2))];

      const contexts = [];
      if (globalContext) {
        contexts.push(globalContext);
      }
      if (context) {
        contexts.push(context);
      }
    
      return replace(backendApi.phrases.get(contexts, template, languages), fields);
    };
  };
}
